import { Modal } from "ui/Modal"
import BookingDetails from "ui/Booking/Details"
import { useEffect, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getClientBookingDetails } from "store/bookings"
import PropTypes from "prop-types"
import { Flex, Spin } from "antd"

const BookingDetailsModal = ({ open, handleOnCancel, bookingUuid, onCancelSuccess, onAssignmentChange }) => {
  const dispatch = useDispatch()
  const { loading } = useSelector((store) => store?.bookings?.clientBookingDetails) || {}
  const hasLoadedOnce = useRef(false)

  useEffect(() => {
    hasLoadedOnce.current = false
    dispatch(getClientBookingDetails(bookingUuid)).then(() => {
      hasLoadedOnce.current = true
    })
  }, [bookingUuid, dispatch])

  const handleAssignmentChange = () => {
    dispatch(getClientBookingDetails(bookingUuid))
    onAssignmentChange?.()
  }

  return (
    <Modal open={open} onCancel={handleOnCancel}>
      {loading && !hasLoadedOnce.current ? (
        <Flex justify="center" align="center" style={{ minHeight: 200 }}>
          <Spin size="large" />
        </Flex>
      ) : (
        <BookingDetails uuid={bookingUuid} disableLoaderWatcher onCancelSuccess={onCancelSuccess} onAssignmentChange={handleAssignmentChange} />
      )}
    </Modal>
  )
}

BookingDetailsModal.propTypes = {
  open: PropTypes.bool,
  handleOnCancel: PropTypes.func,
  bookingUuid: PropTypes.string,
  onCancelSuccess: PropTypes.func,
  onAssignmentChange: PropTypes.func
}

export default BookingDetailsModal
